import './index.scss';
import React, {Component} from 'react';
//import CSVFile from '../assets/non-deere-claims-report.csv';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {customizeErrorAlert} from '../shared/services/customize-error-alert-bar';
import {showLoadingIndicator} from '../shared/state/busy-counter';
//import {uploadBatchFactoryData, uploadBatchFactoryDataRefineWorklist} from '../repositories';
import _ from 'lodash';
// import {Accordion} from 'react-bootstrap';
import BusyCounterLoadingIndicator from '../shared/components/busyCounter/busy-counter-loading-indicator';
import * as busyCounter from '../shared/action-creator/busy-counter';
import FileUploadPanel from '../mass-update/components/file-upload-panel';
import { createErrorMessage, createSuccessMessage } from '../shared/action-creator/alert-messages';
import OptionsDropDown from '../shared/components/options-drop-down';
import { uploadNonDeereClaims } from '../mass-update/repositories';
import { downloadSampleReports } from '../claims/repositories';
// import { getUserIdFromSessionStorage } from '../shared/services/user-service';

const   factoryList = [
    {
        "id": "liebherr",
        "name": "Liebherr"
    },
    {
        "id": "claas",
        "name": "Claas"
    },
    {
        "id": "wirtgen",
        "name": "Wirtgen"
    }]

    // const loggedInUserId = getUserIdFromSessionStorage();


class NonDeereClaimsUpload extends Component {


    state = {
        fileInfo: {},
        uploadResp: {},
        // uploadStatus: '',
        isRefineWorklist: false,
       factoryType: ''
    }


    componentDidMount() {
        this.props.increaseCounter();
        setTimeout(() => {
            this.props.decreaseCounter();
        }, 500);

    }
    handleFileDrop = files => {
        console.log("handleFileDrop :", this.state.isChecked);
        if (!this.state.factoryType) {
            this.props.createErrorMessage('Please select a factory code before uploading a file.');
            return;
        }
        this.setState({
            fileInfo: files[0],
        });

    }

    handleRejectedFiles = () => {

        this.props.increaseCounter();
        const msg = 'Only CSV files are allowed';
        customizeErrorAlert(msg);
        this.props.decreaseCounter();

    }

    handleSubmitClick = () => {
        this.setState({
            uploadResp: {},
        });
        console.log("***",this.state.factoryType);

        let endPoint = `nondeere-claims/upload/${this.state.factoryType.toLowerCase()}`;
    if( this.state.factoryType!== ""){
        this.props.increaseCounter();
        uploadNonDeereClaims(this.state.fileInfo, endPoint).then(response => {
            console.log("response.status::", response.status);
            console.log("factory type string::", endPoint);
            if (response.errors.length) {
                response.errors.forEach(element => {
                    customizeErrorAlert(element);
                });

            } else {
                // console.log("response.status::", response.uploadStatisticsMap);
                this.setState({
                    uploadResp: response
                });
                console.log("uploadResp", this.state.uploadResp);
                // this.props.createSuccessMessage( response.status );
            }
            this.props.decreaseCounter();

        }).catch(() => {
            this.props.decreaseCounter();
        });
    }else{
        customizeErrorAlert("Please select Valid factory!")
    }
}

    handleCancleClick = () => {
        this.setState({
            fileInfo: {},
            uploadResp: {},
            // uploadStatus: '',
        });

    }
    handleFactoryChange = obj => {

          const selectedOption = {
            target: {
                name: 'factoryType',
                value: obj === '-1' ? '' : obj,
            },
        };
       this.setState({
            factoryType: selectedOption.target.value
          }
        );
       // this.updateSearchInput( selectedOption );
        console.log(selectedOption.target.value);
      }
    handleDownloadClick = (fileName) => () => {
                console.log("fileName", fileName);
                
                this.props.increaseCounter();
        
                downloadSampleReports(fileName)
                    .then(response => {
                        response.blob().then( blob => {
                            let fileExtension;
                            if(fileName === 'non-deere-claims-report-claas'){
                                fileExtension = "xlsx";
                            }
                            else{
                                fileExtension = "csv";
                            }
                            const url = window.URL.createObjectURL( blob );
                            const a = document.createElement( 'a' );
                            a.setAttribute( 'download', fileName+'.'+fileExtension );
                            a.href = url;
                            document.body.appendChild( a );
                            a.click();
                            a.parentNode.removeChild( a );
                    
                        } );
                        this.props.decreaseCounter();
                    })
                    .catch(() => {
                        this.props.decreaseCounter();
                    });
            }
    render() {
        const containerStyle = {
            // marginTop: '1%',
            backgroundColor: 'white',
            border: '1px solid black',
            borderStyle: 'dotted',
            borderRadius: '4px',
            paddingLeft: '10px',
            marginLeft: '5px',
            marginRight: '5px',
            fontSize: '14px'
        };

        // const responses = {
        //     'FUNCTION_CD': '2',
        //     'DESIGN_TEAM_CD': '2',
        //     'CORRECT_PART_NUM': '2',
        //     'MFG_DEPT_ID': '2',
        //     'MODEL_YR': '2',
        //     // 'INVALID PRIMEPART NUMBER':"[123,123,234,567,7856]"
        // }
        // const uploadStatus = "TOTAL UPDATED : 100 Out-Off 130 Records."
        // const invalidPrimePartList =  ["N242376", "AKK15554", "AKK15554", "AKK15554", "AKK15554"]
        //
        //
        // const valueStyleStart = {
        //     width: '2%',
        //     display: 'inline-block'
        // };
        // const valueStyleLeft = {
        //     width: '20%',
        //     display: 'inline-block',
        //     fontSize: '12px',
        // };
        // const valueStyleMiddle = {
        //     width: '3%',
        //     display: 'inline-block',
        //     fontSize: '12px',
        //     fontWeight:'bold'
        // };
        // const valueStyleRight = {
        //     width: '40%',
        //     display: 'inline-block',
        //     fontSize: '12px'
        // };
        //
        // const valueStyleLeftListPP = {
        //     width: '75%',
        //     display: 'inline-block',
        //     fontSize: '12px'
        // };
        // const valueStyleLeftListContent = {
        //     width: '8%',
        //     display: 'inline-block',
        //     fontSize: '12px',
        // };
        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter}/>
                <div className="nonDeereClaim-page">
                <div className="header-container">
                <h2 className="header-align">Non Deere Claims</h2>
                <div className="sample-report">
                {this.state.factoryType !== "" && this.state.factoryType === "liebherr" ?
                                    // <a title="Field having values can update only" href={CSVFile}
                                    // download="non-deere-claims-report.csv">Download Sample Report-{this.state.factoryType} </a>
                                    
                                    <a
                                    title="Field having values can update only"
                                    onClick={this.handleDownloadClick('non-deere-claims-report')}
                                    >
                                    Download Sample Report-{this.state.factoryType}
                                </a>
                                
                                    : this.state.factoryType === "claas" ?
                                    // <a title="Field having values can update only" href={CSVFile}
                                    // download="non-deere-claims-report-claas.csv">Download Sample Report-claas</a>
                                    <a
                                    title="Field having values can update only"
                                    onClick={this.handleDownloadClick('non-deere-claims-report-claas')}
                                    >
                                    Download Sample Report
                                </a>
                                    : <div></div>
                                }
                               
                                </div>
                                <div className="drop-down-style">
                            <OptionsDropDown
                            isPlaceholderTranslated={true}
                            optionDisplayAttributes={['name']}
                            optionKey="id"
                            options={factoryList}
                            onChange={this.handleFactoryChange}
                            placeholder="Select Factory"
                            selectedValue={this.state.factoryType}
                            />
                            </div>
                            
                        </div>

                  

                    <FileUploadPanel
                        handleFileDrop={this.handleFileDrop}
                        handleRejectedFiles={this.handleRejectedFiles}
                        handleSubmitClick={this.handleSubmitClick}
                        handleCancleClick={this.handleCancleClick}
                        fileName={this.state.fileInfo.name}
                        fileType={this.state.factoryType === "claas" ? ".xlsx" : ".csv"}
                    />
                </div>

        

                {
                    (!_.isEmpty(this.state.uploadResp)) ?
                        <div style={containerStyle}>
                            <span role="img" aria-label="imag">{this.state.uploadResp.status} &#9989; </span>
                            {/* {
                                Object.entries(this.state.uploadResp.uploadStatisticsMap).map(([key, value]) =>
                                    <small>
                                        <ul>
                                            <li style={valueStyleStart}>&#10004;</li>
                                            <li style={valueStyleLeft}>{key}</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleRight}>{value} Records</li>
                                        </ul>
                                    </small>
                                )} */}

                        </div> : null
                }

            </section>
        );

    }

}

NonDeereClaimsUpload.displayName = 'NonDeereClaimsUpload';
NonDeereClaimsUpload.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories
});
const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
    createSuccessMessage: message => dispatch(createSuccessMessage(message)),
    createErrorMessage: message => dispatch(createErrorMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NonDeereClaimsUpload)